// Migrated from app/assets/javascripts/admin.js.erb
// Admin layout entrypoint - loads jQuery, jQuery UI, plugins, and admin utilities

import 'rollbar'

// jQuery as window global (needed by vendor plugins)
import 'libraries/jquery-global'
import 'jquery-ujs'
import 'jquery-ui-dist/jquery-ui'
// jQuery UI CSS is loaded via Sprockets (Redmond theme) - don't import default theme here

// jQuery UI locale and timepicker
import 'vendor/jquery-ui-timepicker-addon'
import 'vendor/jquery-ui-datepicker-nl'
import 'vendor/jquery-ui-timepicker-nl'

// jQuery extensions
import 'vendor/jquery.qtip'
import 'vendor/jquery.prettyPhoto'
import 'vendor/jquery.prevent_double_click'
import 'vendor/jquery.mousewheel'
import 'vendor/jquery.sprintf'

// jQuery plugins from gems (stubs until Docker extraction)
import 'vendor/jquery.purr'
import 'vendor/best-in-place'

// jquery-minicolors (vendored for ESM compat, also inits .color elements via color-scheme-init)
import 'vendor/jquery.minicolors'
import 'libraries/color-scheme-init'

// Notification libraries
import 'sweetalert'
import toastr from 'toastr'
window.toastr = toastr

// Admin extensions (best_in_place init, remove/add fields, slide toggle)
import 'libraries/admin-ext'

// Common utilities (flash, inIframe)
import 'libraries/common'

// Admin legacy inline code
import 'libraries/admin-legacy'
